import { z } from 'zod';
import { optionalString, optionalNumber, optionalDate } from './helpers';

export const PAY_FREQUENCIES = ['monthly', 'semi_monthly', 'weekly'] as const;
export const WITHHOLDING_TAX_PERIODICITIES = ['monthly', 'quarterly', 'annual'] as const;
export const ADMINISTRATION_BASES = ['avs_contributions', 'gross_avs'] as const;

export const payrollSettingsSchema = z.object({
  avs_fund: z.object({
    name: optionalString(),
    member_number: optionalString(),
    administration_rate: optionalNumber(),
    administration_base: z.preprocess(
      (val) => (val === '' ? null : val),
      z.enum(ADMINISTRATION_BASES).nullable().optional()
    ),
  }).default({ name: null, member_number: null, administration_rate: null, administration_base: null }),

  family_allowance_fund: z.object({
    name: optionalString(),
    member_number: optionalString(),
    contribution_rate: optionalNumber(),
  }).default({ name: null, member_number: null, contribution_rate: null }),

  withholding_tax: z.object({
    canton: optionalString(),
    debtor_number: optionalString(),
    periodicity: z.preprocess(
      (val) => (val === '' ? null : val),
      z.enum(WITHHOLDING_TAX_PERIODICITIES).nullable().optional()
    ),
  }).default({ canton: null, debtor_number: null, periodicity: null }),

  pay_frequency: z.enum(PAY_FREQUENCIES).default('monthly'),

  expense_regulation: z.object({
    approved: z.boolean().default(false),
    canton: optionalString(),
    approved_date: optionalDate(),
    reference: optionalString(),
  }).default({ approved: false, canton: null, approved_date: null, reference: null }),
});

export type PayrollSettingsFormData = z.input<typeof payrollSettingsSchema>;
export type PayrollSettingsPayload = z.output<typeof payrollSettingsSchema>;
